import api, { ValidateAxiosError } from '@/modules/api.service'
import { IQueryComarcas } from '@/api.types';

export async function GetRelatorioLotacoesPorEstagiarios() {
  return api.get<IQueryComarcas[]>('/lotacoes-estagiario')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<IQueryComarcas[]>(error, 'Falha ao buscar relatório');
    });
}